"use client";

import { ArrowRight } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const platforms = [{
  id: 1,
  title: "Real-Time Collaboration",
  description: "Work seamlessly with your team and accountants in one unified cloud workspace with instant updates.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/real_time_collaboration_dashboard.png",
  linkText: "Explore Collaboration",
  linkTo: "#"
}, {
  id: 2,
  title: "Automated Workflows",
  description: "Eliminate repetitive tasks with intelligent automation that learns and adapts to your business processes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/automated_workflows_interface.png",
  linkText: "View Automation",
  linkTo: "#"
}, {
  id: 3,
  title: "Advanced Reporting",
  description: "Generate comprehensive financial reports and insights with customizable templates and live data visualization.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/advanced_reporting_analytics.png",
  linkText: "Discover Reports",
  linkTo: "#"
}];
export default function PlatformOverview() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return;
}